import TableDetailPanel from "@common/table/body/tableDetailPanel"
import BodyCell from "@common/table/body/tableBodyCell"
import React, { useRef } from "react"
import { ReactTableProps, RowExpandState, TableRowProps } from "@common/table/types"
import { isFunction, joinClassNames } from "@common/lib/util"

type TableBodyRowProps = TableRowProps &
  RowExpandState &
  Pick<ReactTableProps, "onRowClick" | "wrapRowInLink" | "getLinkHref">
const TableBodyRow = ({
  table,
  row,
  onRowClick,
  expandedRowId,
  setExpandedRowId,
  wrapRowInLink,
  getLinkHref,
  virtualRow,
  rowVirtualizer,
}: TableBodyRowProps) => {
  const {
    options: { renderRowExpandDetails },
  } = table

  const handleRowClick = () => {
    onRowClick?.(row.original, expandedRowId === row.id)
    if (renderRowExpandDetails) setExpandedRowId(row.id)
    if (row.getCanExpand() && !row.getIsExpanded()) row.toggleExpanded(true)
  }
  const rowLink = wrapRowInLink ? getLinkHref?.(row.original) : undefined
  const isRowClickable = !!rowLink || isFunction(onRowClick)
  return (
    <>
      <tr
        key={row.id}
        className={joinClassNames(
          "table-row group",
          isRowClickable ? "cursor-pointer" : ""
        )}
        onClick={handleRowClick}
        style={
          virtualRow && {
            display: "flex",
            position: "absolute",
            top: 0,
            width: "100%",
            height: `${virtualRow.size}px`,
            transform: `translateY(${virtualRow.start}px)`,
          }
        }
        ref={rowVirtualizer?.measureElement}
      >
        {row.getVisibleCells().map((cell, index) => {
          return (
            <BodyCell
              key={cell.id}
              cell={cell}
              table={table}
              row={row}
              colIndex={index}
              rowLink={rowLink}
              expandedRowId={expandedRowId}
            />
          )
        })}
      </tr>
      {renderRowExpandDetails && expandedRowId === row.id && (
        <TableDetailPanel table={table} row={row} expandedRowId={expandedRowId} />
      )}
    </>
  )
}

export default TableBodyRow
